import { SenderModel } from "@cakemail-org/ui-components-v2"

export enum EDomainAuthStatus {
    Authenticated = "authenticated",
    Unauthenticated = "unauthenticated",
    Blocked = "blocked"
}

export type TSendersListing = {
    setSingleSender?: (sender: SenderModel | null) => void
}

/**
 * Domain authentication status data
 * Tracks whether a domain has been authenticated via DKIM, SPF, DMARC
 */
export type TDomainAuthentication = {
    // Overall authentication status (true if all protocols verified)
    authenticated?: boolean | null

    // DMARC protocol data (TODO: define proper type when implementing)
    dmarc?: any

    // SPF protocol data (TODO: define proper type when implementing)
    spf?: any

    // DKIM protocol data (TODO: define proper type when implementing)
    dkim?: any
}

/**
 * Dictionary of domains and their authentication status
 * Key: domain name (e.g., "example.com")
 * Value: authentication data
 */
export type TDomainsList = {
    [domain: string]: TDomainAuthentication
}